import {
  CButton,
  CDataTable,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { getList } from "../../api/generics";
import {
  MOVEMENT_LOG_ACTIONS,
  TreasuryMovement,
  TreasuryMovementLog,
} from "../../models/treasury";
import { formatDateTime } from "../../utils/dates";
import { SUCCESS } from "../../utils/constants/tags";
import { warningAlert } from "../utils/messages";

interface TreasuryMovementLogModalProps {
  movement?: TreasuryMovement;
  onClose: () => void;
}

const TreasuryMovementLogModal: React.FC<TreasuryMovementLogModalProps> = ({
  movement,
  onClose,
}) => {
  const fields = [
    { key: "createdAt", label: "Fecha" },
    { key: "action", label: "Acción" },
    { key: "userName", label: "Usuario" },
    { key: "changes", label: "Detalle" },
  ];
  const [logs, setLogs] = useState<TreasuryMovementLog[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async (movementId: number) => {
    setLoading(true);
    const logsStatus = await getList<TreasuryMovementLog>(
      `/treasury/movements/${movementId}/logs/`,
      -1,
      0
    );
    if (logsStatus.status === SUCCESS && logsStatus.data) {
      setLogs(logsStatus.data.items);
    } else {
      warningAlert(logsStatus.detail ?? "Error desconocido");
    }
    setLoading(false);
  };

  useEffect(() => {
    setLogs([]);
    if (movement !== undefined) {
      fetchLogs(movement.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [movement]);

  return (
    <CModal show={movement !== undefined} onClose={onClose} size="lg">
      <CModalHeader closeButton>
        <CModalTitle>Historial del movimiento #{movement?.id}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {movement?.createdByUserName === undefined && logs.length === 0 ? (
          <p className="text-muted">
            Movimiento generado automáticamente, sin historial de acciones.
          </p>
        ) : (
          <></>
        )}
        <CDataTable
          noItemsView={<p className="text-center">Sin registros</p>}
          fields={fields}
          items={logs}
          loading={loading}
          striped
          border
          scopedSlots={{
            createdAt: (item: TreasuryMovementLog) => (
              <td>{formatDateTime(new Date(item.createdAt))}</td>
            ),
            action: (item: TreasuryMovementLog) => (
              <td>{MOVEMENT_LOG_ACTIONS.get(item.action) ?? item.action}</td>
            ),
            userName: (item: TreasuryMovementLog) => (
              <td>{item.userName ?? "-"}</td>
            ),
            changes: (item: TreasuryMovementLog) => (
              <td>{item.changes ?? "-"}</td>
            ),
          }}
        />
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cerrar
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default TreasuryMovementLogModal;
